module.exports = __webpack_public_path__ + "img/03.716c85ec.jpg";